<template>
  <div/>
</template>

<script setup lang="ts">
import { watch } from 'vue';
import { useStore } from 'vuex';
import { latestMessage, type WebSocketMessageWithFields, type WebSocketMessageEmpty } from '@/plugins/ws';

import {RootState} from "@/store";

const store = useStore<RootState>();

defineOptions({
  name: 'dataLanguageGroups',
});

// Базовый тип для сообщений с ID языковой группы
type LanguageGroupWithId = {
  idLanguageGroup: number;
};

// Типы для WebSocket сообщений компонента languageGroups
type LanguageGroupItemListMessage = WebSocketMessageWithFields<'language-group-item-list', {
  languageGroup: unknown;
}>;
type LanguageGroupsListMessage = WebSocketMessageWithFields<'language-group-list', {
  languageGroups: unknown[];
}>;
type LanguageGroupCreateMessage = WebSocketMessageWithFields<'language-group-create' | 'language-group-create-success', LanguageGroupWithId & {
  name: string;
}>;
type LanguageGroupDeleteMessage = WebSocketMessageWithFields<'language-group-delete' | 'language-group-delete-success', LanguageGroupWithId>;

// Объединенный тип для всех сообщений
type LanguageGroupsWebSocketMessage = 
  | LanguageGroupItemListMessage 
  | LanguageGroupsListMessage 
  | LanguageGroupCreateMessage 
  | LanguageGroupDeleteMessage;

// WebSocket message handler
const handleWebSocketMessage = (data: LanguageGroupsWebSocketMessage): void => {
  if (!data?.signal) return;

  switch (data.signal) {
    case 'language-group-item-list':
      store.dispatch('languageGroup/wsSetLanguageGroup', data.languageGroup);
      break;

    case 'language-group-list':
      store.dispatch('languageGroups/wsSetLanguageGroups', { languageGroups: data.languageGroups });
      break;

    case 'language-group-create':
    case 'language-group-create-success':
      store.dispatch('languageGroups/wsLanguageGroupCreate', {
        idLanguageGroup: data.idLanguageGroup,
        name: data.name,
      });
      break;

    case 'language-group-delete':
    case 'language-group-delete-success':
      store.dispatch('languageGroups/wsLanguageGroupDelete', { idLanguageGroup: data.idLanguageGroup });
      break;
  }
};

watch(latestMessage, handleWebSocketMessage);
</script>
